import styled from 'styled-components';
import { breakpoints, colors } from '../../constants';

interface IProps {
    className?: string;
    children: React.ReactNode;
}

const BaseStepContainer = ({ className, children }: IProps) => (
    <div className={className}>{children}</div>
);

export const StepContainer = styled(BaseStepContainer)`
    position: relative;
    background-color: ${colors.greyLighter};
    padding: 24px 16px;
    border-left: ${`3px solid ${colors.black}`};
    margin-top: 16px;

    @media (${breakpoints.mediumMin}) {
        padding: 32px;
    }
`;
